<div class="wrapper flex flex-col justify-between">
  <div class="heading text-type-2 mb-[20px] flex justify-between items-center">
    <span>{{ pkg?.package_number || 'Package Detail' }}</span>
    <div class="flex items-center gap-[12px]">
      @if (pkg?.status === 'draft' && isPM()) {
        <app-secondary-button (handleClick)="editPackage()">Edit</app-secondary-button>
        <button (click)="deletePackage()" class="delete-icon-button" aria-label="Delete package">
          <mat-icon svgIcon="trash" class="text-red-500" />
        </button>
      }
    </div>
  </div>

  <mat-tab-group class="contents-tab-group flex-1" [selectedIndex]="selectedTabIndex" (selectedIndexChange)="selectedTabIndex = $event">
    <mat-tab label="Details">
      <div class="details-content pt-[20px]">
        <!-- Status -->
        <div class="row-details flex flex-col gap-[4px] mb-[20px]">
          <div class="label w-full">Status</div>
          <div class="value w-full">
            @if (pkg?.status && packageStatusMap[pkg.status]) {
              <div
                [ngClass]="[packageStatusMap[pkg.status].bgColor, packageStatusMap[pkg.status].textColor]"
                class="status-chip px-[14px] rounded-full w-fit">
                {{ packageStatusMap[pkg.status].label }}
              </div>
            }
          </div>
        </div>

        <!-- Title -->
        <div class="row-details flex flex-col gap-[4px] mb-[20px]">
          <div class="label w-full">Title</div>
          <div class="value w-full text-type-11">{{ pkg?.title || 'N/A' }}</div>
        </div>

        <!-- Description -->
        @if (pkg?.description) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full">Description</div>
            <div class="value w-full text-type-11">{{ pkg.description }}</div>
          </div>
        }

        <!-- Sent By -->
        @if (pkg?.sent_by_first_name) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full">Sent By</div>
            <div class="value w-full">
              <div class="flex items-center gap-[8px]">
                <div class="avatar">{{ getInitials(pkg.sent_by_first_name, pkg.sent_by_last_name) }}</div>
                <div class="flex flex-col">
                  <span class="text-type-11">{{ pkg.sent_by_first_name }} {{ pkg.sent_by_last_name }}</span>
                  @if (pkg?.sent_date) {
                    <span class="text-type-14 text-[#60698B]">{{ pkg.sent_date | date:'MMM d, y' }}</span>
                  }
                </div>
              </div>
            </div>
          </div>
        }

        <!-- Sent To -->
        @if (pkg?.sent_to_contractor_name) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full">Sent To</div>
            <div class="value w-full text-type-11">{{ pkg.sent_to_contractor_name }}</div>
          </div>
        }

        <!-- Description -->
        @if (pkg?.description) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full">Description</div>
            <div class="value w-full text-type-11">{{ pkg.description }}</div>
          </div>
        }

        <!-- Due Date -->
        @if (pkg?.due_date) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full">Due Date</div>
            <div class="value w-full text-type-11">{{ pkg.due_date | date:'MMM d, y' }}</div>
          </div>
        }

        <!-- Response Description -->
        @if (pkg?.response_description) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full">Response</div>
            <div class="value w-full text-type-11">{{ pkg.response_description }}</div>
          </div>
        }

        <!-- Response Date -->
        @if (pkg?.response_date) {
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full">Response Date</div>
            <div class="value w-full text-type-11">{{ pkg.response_date | date:'MMM d, y' }}</div>
          </div>
        }

        <!-- Claims -->
        @if (pkg?.claims?.length) {
          <hr class="hr-line" />
          <div class="row-details flex flex-col gap-[4px] mb-[20px]">
            <div class="label w-full flex items-center gap-[8px]">
              Claims
              <span class="count-badge">{{ pkg.claims.length }}</span>
            </div>
            <div class="claims-list mt-[8px]">
              @for (claim of pkg.claims; track claim.id) {
                <div class="claim-item flex flex-col gap-[4px] mb-[8px]">
                  <div class="text-type-11 font-medium">{{ claim.claim_number }} - {{ claim.title }}</div>
                  <div class="flex items-center gap-[8px] flex-wrap">
                    @if (claim.severity && severityMap[claim.severity]) {
                      <span
                        [ngClass]="[severityMap[claim.severity].bgColor, severityMap[claim.severity].textColor]"
                        class="item-badge px-[8px] rounded-full">
                        {{ severityMap[claim.severity].label }}
                      </span>
                    }
                    @if (claim.status && statusMap[claim.status]) {
                      <span
                        [ngClass]="[statusMap[claim.status].bgColor, statusMap[claim.status].textColor]"
                        class="item-badge px-[8px] rounded-full">
                        {{ statusMap[claim.status].label }}
                      </span>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- Location Map with KMZ download -->
        @if (pkg?.status !== 'draft' && claimLocations.length > 0) {
          <hr class="hr-line" />
          <div class="map-section mb-[20px]">
            <div class="label w-full mb-[8px]">LOCATION</div>
            <div class="minimap-container">
              <app-location-picker
                [isDialog]="false"
                [latitude]="mapCenter.lat"
                [longitude]="mapCenter.lng"
                height="150px"
                [readOnly]="true"
              />
            </div>
          </div>
        }

        <!-- Action Section -->
        @if (availableActions.length > 0) {
          <hr class="hr-line" />
          <div class="action-section mb-[20px]">
            <app-dropdown
              [options]="actionDropdownOptions"
              [parentFormGroup]="actionForm"
              class="w-full mb-[12px]"
              controlName="action"
              placeholder="Take action on this package"
              label="actions"
            />

            <!-- Respond form fields -->
            @if (selectedAction === 'respond') {
              <div class="action-form mt-[12px]">
                <app-text-area
                  [parentFormGroup]="respondForm"
                  class="w-full mb-[12px]"
                  controlName="description"
                  label="comment"
                />

                <div class="label w-full mb-[8px]">Claim Responses</div>
                @for (cs of respondClaimStatuses; track cs.claim_id) {
                  <div class="respond-claim-row mb-[12px] p-[12px] border border-[#E9ECF4] rounded-[8px]">
                    <div class="text-type-11 font-medium mb-[8px]">{{ cs.claim_number }} - {{ cs.claim_title }}</div>
                    <div class="flex gap-[12px] items-center mb-[4px]">
                      <select [(ngModel)]="cs.status" class="respond-select">
                        <option value="">Select status</option>
                        @for (opt of itemStatusOptions; track opt.value) {
                          <option [value]="opt.value">{{ opt.label }}</option>
                        }
                      </select>
                    </div>
                    <input [(ngModel)]="cs.comments" class="respond-input mt-[8px]" placeholder="Comments..." />
                  </div>
                }
              </div>
            }

            <!-- Forward form fields -->
            @if (selectedAction === 'forward') {
              <div class="action-form mt-[12px]">
                <app-text-input
                  [parentFormGroup]="forwardForm"
                  class="w-full mb-[12px]"
                  controlName="title"
                  label="title"
                />
                <app-text-area
                  [parentFormGroup]="forwardForm"
                  class="w-full mb-[12px]"
                  controlName="description"
                  label="description"
                />
                <app-dropdown
                  [options]="forwardContractorOptions"
                  [parentFormGroup]="forwardForm"
                  class="w-full mb-[12px]"
                  controlName="sent_to_contractor_id"
                  label="select subcontractor"
                />

                @if (forwardAccounts.length) {
                  <div class="label w-full mb-[8px]">Notify Accounts</div>
                  @for (fa of forwardAccounts; track fa.account_id) {
                    <div class="flex items-center gap-[8px] mb-[8px]">
                      <mat-checkbox
                        [checked]="fa.selected"
                        (change)="toggleForwardAccount(fa)"
                        color="primary"
                      ></mat-checkbox>
                      <span class="text-type-11">{{ fa.name }}</span>
                      <span class="text-type-14 text-[#60698B]">{{ fa.email }}</span>
                    </div>
                  }
                }

                <div class="label w-full mb-[8px]">Claims to Forward</div>
                @for (fc of forwardClaims; track fc.claim_id) {
                  <div class="flex items-center gap-[8px] mb-[8px]">
                    <mat-checkbox
                      [checked]="fc.selected"
                      (change)="toggleForwardClaim(fc)"
                      color="primary"
                    ></mat-checkbox>
                    <span class="text-type-11">{{ fc.claim_number }} - {{ fc.claim_title }}</span>
                  </div>
                }
              </div>
            }

            <!-- Confirm button -->
            @if (selectedAction) {
              <app-primary-button (handleClick)="confirmAction()" class="w-full mt-[12px]">Confirm</app-primary-button>
            }
          </div>
        }
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
